export enum AppointmentCheckupStatus {
	COMPLETE = 'complete',
	SCHEDULED = 'scheduled',
	NONE = 'none',
	NOTAPPLIED = 'notApplied',
	PENDING_RESULT = 'pendingResult',
	REQUESTED = 'requested',
	PENDENT = 'pendent',
	FINISHED = 'finished',
	FINISHED_WITHOUT_MEDICAL_RECORD = 'finishedWithoutMedicalRecord',
}
